// src/components/layout/MobileNav.jsx

import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  FaThLarge, FaUsers, FaStar, FaCommentDots, FaUser,
  FaHeart, FaBell, FaSearch
} from 'react-icons/fa';

const MobileNav = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  // ✅ Screen size detect karo
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // ✅ Screen size ke hisaab se sizes
  const isSmall = screenWidth < 360;    // Extra small
  const isMedium = screenWidth < 480;   // Small mobile
  const isLarge = screenWidth < 640;    // Regular mobile

  const navItems = [
    { path: '/dashboard', icon: FaThLarge, label: 'Home', color: '#e91e63' },
    { path: '/biodata', icon: FaUsers, label: 'Matches', color: '#9c27b0' },
    { path: '/shortlisted', icon: FaHeart, label: 'Shortlist', color: '#ff5722' },
    { path: '/messages', icon: FaCommentDots, label: 'Chats', color: '#2196f3' },
    { path: '/profile', icon: FaUser, label: 'Profile', color: '#4caf50' },
  ];

  return (
    <>
      <style>{`
        /* ===== CSS Variables ===== */
        .mnav-container {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          background: #ffffff;
          border-top: 1px solid rgba(0, 0, 0, 0.08);
          box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
          z-index: 40;
          padding: 6px 0 max(6px, env(safe-area-inset-bottom));
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
        }

        .mnav-wrap {
          display: flex;
          justify-content: space-around;
          align-items: center;
          max-width: 500px;
          margin: 0 auto;
          padding: 0 4px;
        }

        .mnav-link {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 6px 8px;
          border-radius: 12px;
          text-decoration: none;
          color: #9ca3af;
          transition: all 0.25s ease;
          min-width: 56px;
          position: relative;
          flex: 1;
          max-width: 80px;
        }

        .mnav-link:active {
          transform: scale(0.92);
        }

        /* Active state */
        .mnav-link.active {
          color: #e91e63;
        }

        /* Icon container */
        .mnav-icon-wrap {
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
          transition: all 0.3s ease;
          margin-bottom: 2px;
        }

        .mnav-link.active .mnav-icon-wrap {
          background: linear-gradient(135deg, #ff0055, #ff4d88);
          box-shadow: 0 4px 12px rgba(255, 0, 85, 0.35);
          transform: translateY(-2px);
        }

        .mnav-link.active .mnav-icon {
          color: #fff !important;
          font-size: 16px;
        }

        .mnav-icon {
          font-size: 18px;
          transition: all 0.25s ease;
        }

        .mnav-label {
          font-size: 10px;
          font-weight: 600;
          margin-top: 2px;
          transition: all 0.25s ease;
          letter-spacing: 0.2px;
        }

        .mnav-link.active .mnav-label {
          color: #e91e63;
          font-weight: 700;
          font-size: 10.5px;
        }

        /* Active dot indicator */
        .mnav-active-dot {
          position: absolute;
          top: 3px;
          width: 4px;
          height: 4px;
          background: #ff0055;
          border-radius: 50%;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .mnav-link.active .mnav-active-dot {
          opacity: 1;
        }

        /* ===== TABLET (max 768px) ===== */
        @media (max-width: 768px) {
          .mnav-container {
            display: block;
          }
        }

        /* ===== REGULAR MOBILE (max 640px) ===== */
        @media (max-width: 640px) {
          .mnav-container {
            padding: 5px 0 max(5px, env(safe-area-inset-bottom));
          }

          .mnav-link {
            padding: 5px 6px;
            min-width: 52px;
          }

          .mnav-icon-wrap {
            width: 30px;
            height: 30px;
          }

          .mnav-icon {
            font-size: 17px;
          }

          .mnav-link.active .mnav-icon {
            font-size: 15px;
          }

          .mnav-label {
            font-size: 9.5px;
          }

          .mnav-link.active .mnav-label {
            font-size: 10px;
          }
        }

        /* ===== SMALL MOBILE (max 480px) ===== */
        @media (max-width: 480px) {
          .mnav-container {
            padding: 4px 0 max(4px, env(safe-area-inset-bottom));
          }

          .mnav-wrap {
            padding: 0 2px;
          }

          .mnav-link {
            padding: 4px 5px;
            min-width: 48px;
            border-radius: 10px;
          }

          .mnav-icon-wrap {
            width: 28px;
            height: 28px;
            border-radius: 9px;
          }

          .mnav-icon {
            font-size: 16px;
          }

          .mnav-link.active .mnav-icon {
            font-size: 14px;
          }

          .mnav-link.active .mnav-icon-wrap {
            transform: translateY(-1px);
            box-shadow: 0 3px 10px rgba(255, 0, 85, 0.3);
          }

          .mnav-label {
            font-size: 9px;
            margin-top: 1px;
          }

          .mnav-link.active .mnav-label {
            font-size: 9.5px;
          }
        }

        /* ===== EXTRA SMALL (max 360px) ===== */
        @media (max-width: 360px) {
          .mnav-link {
            padding: 3px 4px;
            min-width: 44px;
          }

          .mnav-icon-wrap {
            width: 26px;
            height: 26px;
          }

          .mnav-icon {
            font-size: 15px;
          }

          .mnav-link.active .mnav-icon {
            font-size: 13px;
          }

          .mnav-label {
            font-size: 8.5px;
          }
        }

        /* ===== TINY SCREEN (max 320px) ===== */
        @media (max-width: 320px) {
          .mnav-icon-wrap {
            width: 24px;
            height: 24px;
          }

          .mnav-icon {
            font-size: 14px;
          }

          .mnav-label {
            font-size: 8px;
          }
        }

        /* ===== LANDSCAPE MOBILE ===== */
        @media (max-height: 500px) and (orientation: landscape) {
          .mnav-container {
            padding: 2px 0 max(2px, env(safe-area-inset-bottom));
          }

          .mnav-link {
            padding: 3px 6px;
          }

          .mnav-icon-wrap {
            width: 24px;
            height: 24px;
            margin-bottom: 0;
          }

          .mnav-icon {
            font-size: 14px;
          }

          .mnav-label {
            font-size: 8.5px;
            margin-top: 1px;
          }
        }

        /* ===== HIDE ON DESKTOP ===== */
        @media (min-width: 769px) {
          .mnav-container {
            display: none;
          }
        }

        /* ===== DARK MODE (optional) ===== */
        @media (prefers-color-scheme: dark) {
          .mnav-container {
            background: #1a1a1a;
            border-top-color: rgba(255, 255, 255, 0.1);
          }
        }

        /* ===== IOS Safe Area ===== */
        @supports (padding: max(0px)) {
          .mnav-container {
            padding-bottom: max(6px, env(safe-area-inset-bottom));
          }
        }

        /* ===== Hover on devices that support it ===== */
        @media (hover: hover) {
          .mnav-link:hover:not(.active) {
            color: #ff4d88;
            background: rgba(255, 0, 85, 0.05);
          }

          .mnav-link:hover:not(.active) .mnav-icon-wrap {
            background: rgba(255, 0, 85, 0.08);
          }
        }

        /* ===== Accessibility - Focus ===== */
        .mnav-link:focus-visible {
          outline: 2px solid #ff0055;
          outline-offset: 2px;
        }

        /* ===== Ripple effect on tap ===== */
        .mnav-link {
          -webkit-tap-highlight-color: transparent;
          user-select: none;
        }
      `}</style>

      <nav className="mnav-container" role="navigation" aria-label="Mobile navigation">
        <div className="mnav-wrap">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `mnav-link ${isActive ? 'active' : ''}`
                }
              >
                <span className="mnav-active-dot"></span>
                <div className="mnav-icon-wrap">
                  <Icon className="mnav-icon" />
                </div>
                <span className="mnav-label">{item.label}</span>
              </NavLink>
            );
          })}
        </div>
      </nav>
    </>
  );
};

export default MobileNav;